// ResizeObserverErrorFix.ts라는 파일 생성
export function fixResizeObserverErrors() {
    const errorHandler = (e: ErrorEvent) => {
      if (e.message.includes('ResizeObserver loop')) {
        e.stopPropagation();
        e.preventDefault();
        console.warn('ResizeObserver 루프 에러 억제됨');
      }
    };
  
    window.addEventListener('error', errorHandler);
    
    // ResizeObserver의 기본 구현을 오버라이드
    class PatchedResizeObserver extends ResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        super((entries, observer) => {
          // requestAnimationFrame으로 콜백 래핑
          window.requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (e) {
              console.warn('ResizeObserver 콜백 에러 억제됨:', e);
            }
          });
        });
      }
    }
    
    // 전역 ResizeObserver 교체
    window.ResizeObserver = PatchedResizeObserver;
    
    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }